<template>
	<a
		class="card card--no-gutter facetted-list-item list-item grid-noGutter"
		:class="{ 'list-item--mounted': isMounted }"
		:href="data.link"
	>
		<span class="facetted-list-item_icon" v-html="IconCalendar"></span>
		<div
			v-if="!showPattern"
			class="facetted-list-item__image"
			v-html="data.image"
		></div>
		<div
			v-if="showPattern"
			class="facetted-list-item__pattern"
			v-html="Pattern"
		></div>
		<div class="facetted-list-item__inner">
			<h3
				class="facetted-list-item__title header-extra-small"
				:id="'facetted-list-title__' + data.id"
			>
				{{ data.title }}
			</h3>
			<div class="grid">
				<div class="col-6">
					<p
						class="facetted-list-item__label"
						:aria-describedby="'facetted-list-title__' + data.id"
					>
						{{ labelDate }}
					</p>
					<p
						class="facetted-list-item__value"
						:aria-describedby="'facetted-list-title__' + data.id"
					>
						{{ formatDateNoLeadingZeros(data.date) }}
						<template
							v-if="
								data.endDate != '' && data.endDate != data.date
							"
						>
							&nbsp;-
							<br />
							{{ formatDateNoLeadingZeros(data.endDate) }}
						</template>
					</p>
				</div>
				<div class="col-6">
					<p
						class="facetted-list-item__label"
						:aria-describedby="'facetted-list-title__' + data.id"
					>
						{{ labelLocation }}
					</p>
					<p
						class="facetted-list-item__value"
						:aria-describedby="'facetted-list-title__' + data.id"
					>
						<span
							:aria-label="data.place ? '' : ariaLabelEmptyField"
							>{{ data.place ? data.place : "-" }}</span
						>
					</p>
				</div>
				<div class="col-6">
					<p
						class="facetted-list-item__label"
						:aria-describedby="'facetted-list-title__' + data.id"
					>
						{{ labelTime }}
					</p>
					<p
						class="facetted-list-item__value"
						:aria-describedby="'facetted-list-title__' + data.id"
					>
						<span
							:aria-label="data.place ? '' : ariaLabelEmptyField"
							>{{ data.time ? data.time : "-" }}</span
						>
					</p>
				</div>
				<div class="col-6">
					<p
						class="facetted-list-item__label"
						:aria-describedby="'facetted-list-title__' + data.id"
					>
						{{ labelPrice }}
					</p>
					<p
						class="facetted-list-item__value"
						:aria-describedby="'facetted-list-title__' + data.id"
					>
						<span
							:aria-label="data.price ? '' : ariaLabelEmptyField"
							>{{ data.price ? data.price : "-" }}</span
						>
					</p>
				</div>
			</div>
		</div>
	</a>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import IconCalendar from '../../../../views/icons/calendar.cshtml';
import Pattern from '../../../../views/visuals/leafPatternLarge.cshtml';

const props = defineProps({
  data: Object,
  ariaLabelEmptyField: String,
  labelDate: String,
  labelTime: String,
  labelLocation: String,
  labelPrice: String
});

const isMounted = ref(false);

onMounted(() => {
  setTimeout(() => {
    isMounted.value = true;
  }, 10);
});

const formatDateNoLeadingZeros = (date) => {
  return utilities.formatDateNoLeadingZeros(date, true);
};

const showPattern = computed(() => {
  return props.data.image.length === 0;
});
</script>
